/**
 * Assign records to zones with the one-zone-only rule (AVA-764). The API refuses (409 { conflicts })
 * an assignment that would give a record a second zone of a type that allows one; the user then
 * decides through `askReplace(conflicts, { canSkip })` (ZoneReplaceDialog.ask):
 *   - 'replace': assign again with the explicit replace decision
 *   - 'skip':    keep the current zones and assign only the other items
 *   - 'cancel':  change nothing
 * Resolves to the API result ({ created, skipped, replaced }), or null when nothing was assigned.
 */
const keyOf = (x) => `${x.zoneId}|${x.recordType}|${x.recordId}`;

export async function assignZones(store, items, askReplace) {
  try {
    return await store.dispatch('ZONES/ASSIGN', items);
  } catch (err) {
    const conflicts = err.status === 409 ? err.data?.conflicts : null;
    if (!conflicts?.length) throw err;
    const conflicted = new Set(conflicts.map(keyOf));
    const rest = items.filter((item) => !conflicted.has(keyOf(item)));
    const choice = await askReplace(conflicts, { canSkip: rest.length > 0 });
    if (choice === 'replace') return store.dispatch('ZONES/ASSIGN', { items, replace: true });
    if (choice === 'skip' && rest.length) return store.dispatch('ZONES/ASSIGN', rest);
    return null;
  }
}
